class LoginState {
    setLoginToken = function (token) {
        localStorage.setItem('seed_token', JSON.stringify(token));
    };

    setLoginUserID = function (userID) {
        localStorage.setItem('seed_userID', JSON.stringify(userID));
    };

    setLoginUserName = function (userName) {
        localStorage.setItem('seed_userName', JSON.stringify(userName));
    };

    setLoginAccess = function (access) {
        localStorage.setItem('seed_access', JSON.stringify(access));
    };

    setLoginAvator = function (avatorImgPath) {
        localStorage.setItem('seed_avatorImgPath', JSON.stringify(avatorImgPath));
    };

    setPersonType = function (personType) {
        localStorage.setItem('seed_personType', JSON.stringify(personType));
    };
    setPersonDept = function (personDept) {
        localStorage.setItem('seed_personDept', JSON.stringify(personDept));
    };

    setPersonName = function (personName) {
        localStorage.setItem('seed_personName', JSON.stringify(personName));
    };

    setUserTypeInfo = function (userTypeInfo) {
        localStorage.setItem('seed_userTypeInfo', JSON.stringify(userTypeInfo));
    };

    checkAllStateWell = function () {
        let names = [
            'seed_token',
            'seed_userID',
            'seed_userName',
            'seed_access',
            'seed_avatorImgPath',
            'seed_personName',
            'seed_personType',
            'seed_personDept',
            'seed_userTypeInfo'
        ];
        for (let i = 0; i < names.length; i++) {
            if (localStorage.getItem(names[i]) === null || localStorage.getItem(names[i]) === undefined) {
                return false;
            }
        }
        return true;
    };

    getLoginToken = function () {
        return JSON.parse(localStorage.getItem('seed_token'));
    };

    getLoginUserID = function () {
        return JSON.parse(localStorage.getItem('seed_userID'));
    };

    getLoginUserName = function () {
        return JSON.parse(localStorage.getItem('seed_userName'));
    };

    getLoginAccess = function () {
        return JSON.parse(localStorage.getItem('seed_access'));
    };

    getLoginAvator = function () {
        return JSON.parse(localStorage.getItem('seed_avatorImgPath'));
    };

    getPersonName = function () {
        return JSON.parse(localStorage.getItem('seed_personName'));
    };

    getPersonType = function () {
        return JSON.parse(localStorage.getItem('seed_personType'));
    };
    getPersonDept = function () {
        return JSON.parse(localStorage.getItem('seed_personDept'));
    };

    getUserTypeInfo = function () {
        return JSON.parse(localStorage.getItem('seed_userTypeInfo'));
    };
}

const loginState = new LoginState();
export default loginState;
